import TypesetStyle from 'components/TypesetStyle';
import React from 'react';
export default {
  TypesetStyle,
  React
};